import { Injectable } from "@angular/core";
import * as CryptoJS from "crypto-js";

import { environment } from "src/environments/environment";
import { LocalStorageService } from "./LocalStorage.service";

@Injectable({
  providedIn: "root",
})
export class EncriptionService {
  public isReloading: boolean = false;
  public viewDesencriptado: any = [];  
  
  // Clave secreta para el cifrado
  private secretKey = "claveAntiCambio";


  constructor(
    private localStorageService: LocalStorageService,
  ) {
  }

  EncryptData(data: any): string {
    const encryptedData = CryptoJS.AES.encrypt(
      JSON.stringify(data),
      this.secretKey
    ).toString();
    return encryptedData;
  }

  DecryptData(encryptedData: string): any {
    if (!encryptedData) {
      return null;
    }
    const decryptedBytes = CryptoJS.AES.decrypt(encryptedData, this.secretKey);
    if(decryptedBytes.toString().length == 0){
      return null;
    }
    const decryptedData = JSON.parse(decryptedBytes.toString(CryptoJS.enc.Utf8));
    return decryptedData;
  }

  DecryptViews(){
    this.viewDesencriptado = this.DecryptData(this.localStorageService.getViews());
    this.viewDesencriptado = this.viewDesencriptado.sort( (a,b) => a.idOrder - b.idOrder);
    this.viewDesencriptado = this.viewDesencriptado.filter(view => view.name != "Configuración" && view.name != "Permisos Generales");
    if(!environment.production) console.log("views",this.viewDesencriptado);
    return this.viewDesencriptado;
  }

  DecryptList(): any{
    var rolDesencriptado = null;
    if(this.localStorageService.getPermissions() != null && this.localStorageService.getPermissions() != "" && this.localStorageService.getPermissions() != undefined){
      var permissionEncriptado = JSON.parse(this.localStorageService.getPermissions());
      rolDesencriptado = permissionEncriptado.map(permission => this.DecryptData(permission));
      // if(!environment.production) console.log("permisoooooos",rolDesencriptado);
    }
    return rolDesencriptado;
  }
}
